/**
 * Dev/synthetic patient display name resolution.
 *
 * Provides instant name resolution for known dev/demo patients and checks
 * the recent patients cache so navigating to a patient (e.g. `?patient_id=26917`)
 * displays their human name immediately in the app shell and patient context chip.
 */
import { getRecentPatients } from "./recentPatients";

export const KNOWN_DEV_PATIENTS: Record<string, string> = {
  "26917": "Gabe S.",
  "P-123": "Alice Smith",
  "P-456": "Bob Jones",
  "P-789": "Alex Johnson",
  "SYNTH-PT-0001": "Sample Patient Alpha",
  "SYNTH-PT-0002": "Sample Patient Beta",
  "SYNTH-PT-0003": "Sample Patient Gamma",
};

/**
 * Resolve a display name for a patient ID.
 *
 * Checks:
 * 1. Known dev/demo patients dictionary (e.g. 26917 -> "Gabe S.")
 * 2. Recent patients localStorage cache (if previously recorded with a name)
 *
 * @param patientId - The patient identifier.
 * @returns The resolved display name, or undefined if unknown.
 */
export function resolvePatientName(patientId: string): string | undefined {
  if (!patientId) return undefined;
  if (KNOWN_DEV_PATIENTS[patientId]) {
    return KNOWN_DEV_PATIENTS[patientId];
  }
  const recents = getRecentPatients();
  const matched = recents.find((p) => p.patientId === patientId);
  return matched?.name?.trim() || undefined;
}
